export default __webpack_public_path__ + "ab2df94.png";